import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.74 4.327a1 1 0 0 0-1.48 1.346l3.97 4.368A6.481 6.481 0 0 0 3.81 12H2a1 1 0 1 0 0 1.999h.498a6.5 6.5 0 1 0 12.5 2.386l2.617 2.877a6.53 6.53 0 0 0 2.574 2.832l5.071 5.578a1 1 0 1 0 1.48-1.346zM8.5 12a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M30 16.5a6.5 6.5 0 0 1-4.179 6.073l-1.498-1.648a4.501 4.501 0 1 0-5.15-5.665L16.209 12h2.6a6.48 6.48 0 0 1 4.691-2 6.48 6.48 0 0 1 4.69 2H30a1 1 0 1 1 0 2h-.498A6.5 6.5 0 0 1 30 16.5"
    />
  </svg>
);
const SvgIconEyeglassesSlash = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconEyeglassesSlash);
export default Memo;
